import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "dice-canvas",
    style: _normalizeStyle({ transform: `rotate(${_ctx.canvasRotation}deg)` })
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["dice", `dice-${_ctx.dice[0]}`])
    }, [
      _createElementVNode("div", {
        class: "dice-inner",
        style: _normalizeStyle({ transform: `rotate(${_ctx.dice1Rotation}deg)` })
      }, null, 4)
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(["dice", `dice-${_ctx.dice[1]}`])
    }, [
      _createElementVNode("div", {
        class: "dice-inner",
        style: _normalizeStyle({ transform: `rotate(${_ctx.dice2Rotation}deg)` })
      }, null, 4)
    ], 2)
  ], 4))
}